import { render } from "./notepad.vue?vue&type=template&id=13529501&scoped=true"
import script from "./notepad.vue?vue&type=script&lang=js"
export * from "./notepad.vue?vue&type=script&lang=js"

import "./notepad.vue?vue&type=style&index=0&id=13529501&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13529501"],['__file',"src/components/notepad.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13529501"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13529501', __exports__)) {
    api.reload('13529501', __exports__)
  }
  
  module.hot.accept("./notepad.vue?vue&type=template&id=13529501&scoped=true", () => {
    api.rerender('13529501', render)
  })

}


export default __exports__